import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ActivityTemplate } from '@go-modules/interfaces/activity';
import { environment } from '@admin-tools/environments/environment';

// NOT PROVIDED IN ROOT
@Injectable()
export class ActivityTemplateService {
	private readonly templateOrder = [
		'standard',
		'stimulus_response',
		'feedback_only',
		'conversation_board'
	];

	constructor (private http: HttpClient) {}

	public getTemplates (): Observable<ActivityTemplate[]> {
		return this.http
			.get<ActivityTemplate[]>(`${environment.apiBaseUrl}/activity_templates`)
			.pipe(
				map((templates) =>
					templates.sort(
						(a, b) =>
							this.templateOrder.indexOf(a.slug) - this.templateOrder.indexOf(b.slug)
					)
				)
			);
	}
}
